import { render, staticRenderFns } from "./setDefaultTemplateOrigin.vue?vue&type=template&id=d8c7104a"
import script from "./setDefaultTemplateOrigin.vue?vue&type=script&lang=js"
export * from "./setDefaultTemplateOrigin.vue?vue&type=script&lang=js"
import style0 from "./setDefaultTemplateOrigin.vue?vue&type=style&index=0&id=d8c7104a&rel=stylesheet%2Fscss&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8c7104a')) {
      api.createRecord('d8c7104a', component.options)
    } else {
      api.reload('d8c7104a', component.options)
    }
    module.hot.accept("./setDefaultTemplateOrigin.vue?vue&type=template&id=d8c7104a", function () {
      api.rerender('d8c7104a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/printValidate/setDefaultTemplateOrigin.vue"
export default component.exports